// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RRxxw","left":"styles_left__QUJZu"};